import { AuthMemberCard } from '@tribeplatform/react-components/AuthMemberCard'

import { BC } from '../../types/index.js'

export const AuthMemberCardBlock: BC<Record<string, never>> = ({ ...rest }) => {
  return <AuthMemberCard {...rest} />
}
